module.exports = __webpack_public_path__ + "img/insightHero.d6a1465f.svg";